import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';

import ConfirmPopup from 'common/Popup/ConfirmPopup';

const SelfExclusionConfirmPopup = ({
  onClose,
  onSubmit,
  selectedPeriod,
  selfExclusionsOptions,
}) => {
  const selectedPeriodLabel = useMemo(
    () => selfExclusionsOptions.find(option => option.value === selectedPeriod).text,
    [selfExclusionsOptions, selectedPeriod],
  );

  const selectPeriodHandler = useCallback(() => {
    if (selectedPeriod === 0) {
      NotificationManager.notify({
        message: 'self_exclusion_confirmation_message_forever',
        status: 'success',
        type: 'notification',
      });
    } else {
      NotificationManager.notify({
        message: `self_exclusion_confirmation_title ${selectedPeriodLabel}`,
        status: 'success',
        type: 'notification',
      });
    }
    onSubmit();
  }, []);
  return (
    <ConfirmPopup
      data={{
        onClose,
        onConfirm: selectPeriodHandler,
      }}
      message="self_exclusion_popup_message"
      title="self_exclusion_popup_title"
    />
  );
};

SelfExclusionConfirmPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SelfExclusionConfirmPopup;
